<template>
  <Teleport to="body">
    <div class="work-overlay" @click.self="$emit('close')" @keydown="onKey">
      <section ref="dialog" class="work-dialog" role="dialog" aria-modal="true" aria-labelledby="work-title" tabindex="-1">
        <div class="work-dialog-top"><span class="service-status">Выполнено</span><button ref="closeButton" class="dialog-close" aria-label="Закрыть описание работы" @click="$emit('close')">×</button></div>
        <h2 id="work-title">{{ work.title }}</h2>
        <div class="work-meta"><span>{{ monthYear(work.date) }}</span><span>Договор № {{ work.number }}</span></div>
        <div class="work-dialog-body"><h3>Что было сделано</h3><TaskRichText v-if="work.description_html" :html="work.description_html" kind="work" :record-id="work.id" /><p v-else>{{ work.description || work.title }}</p></div>
        <div class="work-dialog-footer"><span>Работа № {{ work.id }}</span><button class="primary" @click="$emit('close')">Понятно</button></div>
      </section>
    </div>
  </Teleport>
</template>
<script>
import { monthYear } from '@/utils/format'
import TaskRichText from './TaskRichText.vue'
export default {
  components: { TaskRichText },
  props: { work: { type: Object, required: true } },
  emits: ['close'],
  mounted() {
    this.previousFocus = document.activeElement
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    this.$refs.closeButton.focus()
  },
  beforeUnmount() { document.body.style.overflow = this.previousOverflow; this.previousFocus?.focus() },
  methods: {
    monthYear,
    onKey(event) {
      if (event.key === 'Escape') this.$emit('close')
      if (event.key !== 'Tab') return
      const buttons = this.$refs.dialog.querySelectorAll('button')
      if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons[buttons.length - 1].focus() }
      else if (!event.shiftKey && document.activeElement === buttons[buttons.length - 1]) { event.preventDefault(); buttons[0].focus() }
    }
  }
}
</script>
